import { remove } from 'lodash';
import React, { useRef, useEffect, useState } from 'react';

function Card({ item }) {
  const cardTitle = useRef(null);
  const [lineNumber, setLineNumber] = useState(10);

  useEffect(() => {
    window.addEventListener('resize', calculateLineNumber);
    calculateLineNumber();

    return () => window.removeEventListener('resize', calculateLineNumber);
  }, []);

  const calculateLineNumber = () => {
    setLineNumber(Math.floor(cardTitle.current?.offsetHeight / 24));
  };

  return (
    <article className="project__card hover-card" aria-labelledby={item.Id}>
      <div className="project__card-img-wrapper">
        {item.ProjectImage && (
          <img
            data-object-fit="cover"
            src={item.ProjectImage}
            alt={item.ProjectImageAlt}
            width="50"
            height="50"
            className="project__card-img"
            loading="lazy"
          />
        )}

        {item.ProjectFlag && (
          <span className="project__card-flag">{item.ProjectFlag}</span>
        )}
      </div>
      <div className="project__card-content">
        <span className="project__school">{item.ProjectSchool}</span>
        {item.ProjectProgram && (
          <span className="project__program">{item.ProjectProgram}</span>
        )}
        <h3 ref={cardTitle} id={item.Id} className="project__card-heading">
          <a
            href={item.ProjectLinkUrl}
            target={item.ProjectLinkTarget}
            className="project__card-heading-link"
            aria-labelledby={item.id}
          >
            {item.ProjectTitle}
          </a>
        </h3>
        {item.ProjectCopy && (
          <p
            className={
              item.ProjectImage
                ? `project__card-copy-wrapper-${
                  lineNumber ? 5 - lineNumber : 4
                }`
                : `project__card-copy-wrapper--no-image-${
                  lineNumber ? 10 - lineNumber : 9
                }`
            }
          >
            {item.ProjectCopy}
          </p>
        )}
      </div>
    </article>
  );
}

export default Card;
